const CatalogGallery = ({ photos, businessName, onSelect }) => {
  if (!photos.length) return null;

  return (
    <section className="directory-panel__section">
      <h3 className="directory-panel__label">Catálogo</h3>
      <div className="directory-panel__gallery">
        {photos.map((photo, index) => (
          <button
            key={`${photo}-${index}`}
            type="button"
            onClick={() => onSelect(index)}
            aria-label={`Ver foto ${index + 1} del catálogo`}
          >
            <img src={photo} alt={`Foto del catálogo de ${businessName || 'la empresa'}`} />
          </button>
        ))}
      </div>
    </section>
  );
};

export default CatalogGallery;
